import type { PropsWithChildren } from "react";

export const Form = ({ children }: PropsWithChildren<unknown>) => (
  <div className="flex size-full flex-col gap-y-6 px-16 py-12">{children}</div>
);
